import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography, Tab } from '@material-ui/core';

import { SimplePieChart, CustomChartLegend } from 'components';
import { OVERALL_CAPACITY_COLORS, PLATFORMS_COLORS } from './constants';

import useStyles from './styles';
import { getSumOfOverallPercentage } from 'utils/statistics/prepareStatisticsData';

const StatisticsChartsTab = ({
  total,
  overallLegendData,
  platformsLegendData,
  description,
  helpText
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const overallPercentageSum = getSumOfOverallPercentage(overallLegendData);

  if (!overallPercentageSum) {
    overallLegendData.push({ name: 'noData', value: 100 });
  }

  return (
    <div className={classes.leftPanel}>
      <div className={classes.chartWrapper}>
        <Typography className={classes.tabTitle}>
          {t('Overall capacity')}
        </Typography>
        <div className={classes.statisticTab}>
          <SimplePieChart
            data={overallLegendData}
            colorsInfo={OVERALL_CAPACITY_COLORS}
          />
          <CustomChartLegend
            legendData={overallLegendData}
            legendColors={OVERALL_CAPACITY_COLORS}
            legendTitle={`${total}`}
            titleDescription={description}
            helpText={helpText}
          />
        </div>
      </div>
      {platformsLegendData.length !== 0 && (
        <div className={classes.chartWrapper}>
          <Typography className={classes.tabTitle}>{t('Platforms')}</Typography>
          <div className={classes.statisticTab}>
            <SimplePieChart
              data={platformsLegendData}
              colorsInfo={PLATFORMS_COLORS}
            />
            <CustomChartLegend
              legendData={platformsLegendData}
              legendColors={PLATFORMS_COLORS}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default StatisticsChartsTab;
